import React from 'react';
import { CTASection } from '../components/CTASection';
import { ServiceCard } from '../components/ServiceCard';
import { Printer, Shirt, Palette, ScanLine } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Screen Printing',
    description: 'Our core service. We use state-of-the-art automatic presses to deliver consistent, vibrant prints on t-shirts, hoodies, and more. Ideal for orders of 12+ pieces.',
    icon: <Printer data-id="element-384" />,
    accentColor: 'yellow' as const
  }, {
    title: 'Embroidery',
    description: 'We run multi-head embroidery machines capable of handling large orders quickly. Perfect for hats, polos, jackets, and bags that need a professional look.',
    icon: <Shirt data-id="element-385" />,
    accentColor: 'teal' as const
  }, {
    title: 'Direct To Garment',
    description: 'Digital printing that dyes the fabric directly. Great for complex, full-color images and small runs. No minimums required.',
    icon: <Palette data-id="element-386" />,
    accentColor: 'pink' as const
  }, {
    title: 'Textile Laser Etching',
    description: 'A unique process that burns a layer of fabric to create a tone-on-tone look. Works beautifully on fleece and performance fabrics.',
    icon: <ScanLine data-id="element-387" />,
    accentColor: 'yellow' as const
  }];
  return <div className="pt-12 pb-20" data-id="element-388">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-16" data-id="element-389">
        <h1 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-390">Our Services</h1>
        <p className="text-xl text-gray-600" data-id="element-391">
          Comprehensive customization solutions for every need.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-392">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-393">
          {services.map((service, index) => <ServiceCard key={index} {...service} data-id="element-394" />)}
        </div>
      </div>

      <CTASection data-id="element-395" />
    </div>;
}